import { render, staticRenderFns } from "./damage-assessment-ai.vue?vue&type=template&id=22b5707a&scoped=true"
import script from "./damage-assessment-ai.vue?vue&type=script&lang=js"
export * from "./damage-assessment-ai.vue?vue&type=script&lang=js"
import style0 from "./damage-assessment-ai.vue?vue&type=style&index=0&id=22b5707a&prod&scoped=true&lang=css"
import style1 from "./damage-assessment-ai.vue?vue&type=style&index=1&id=22b5707a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5707a",
  null
  
)

export default component.exports